import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-316e46e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "col-12" };
const _hoisted_2 = {
    key: 0,
    class: "row no-gutters w-100 bg-white mt-3"
};
const _hoisted_3 = { class: "col-12 pb-2 mt-3" };
const _hoisted_4 = {
    key: 0,
    class: "row"
};
const _hoisted_5 = { class: "col-12 mb-3" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "images/store_pages/list.svg",
    alt: "list"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "images/store_pages/pin.svg",
    alt: "list"
}, null, -1));
const _hoisted_8 = {
    key: 1,
    class: "row no-gutters",
    style: { "max-height": "2px", "border-top": "1px dotted #000" }
};
const _hoisted_9 = { class: "row mapsWrapper" };
const _hoisted_10 = {
    class: "col-xxl-7 pr-xxl-2 mapDimensionStorePayoutSelection overflow-auto",
    style: { "z-index": "2" }
};
const _hoisted_11 = {
    key: 0,
    class: "row no-gutters w-100 bg-white overflow-hidden"
};
const _hoisted_12 = {
    class: "w-100 bg-white pt-2",
    style: { "height": "110px", "z-index": "2" }
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, null, -1));
const _hoisted_15 = {
    key: 0,
    class: "w-100 mx-3",
    style: { "max-height": "1px", "border-top": "1px dotted #000" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_locations_by_browser_location = _resolveComponent("locations-by-browser-location");
    const _component_locations_map_input_fields = _resolveComponent("locations-map-input-fields");
    const _component_google_maps = _resolveComponent("google-maps");
    const _component_location_card = _resolveComponent("location-card");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_locations_by_browser_location, {
                        class: "buttonBlue",
                        "local-store-payout-only": true
                    }),
                    _createVNode(_component_locations_map_input_fields, { "local-store-payout-only": true })
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
            (_ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["d-inline-block pointerhover switchButton toList mr-2 mb-1", _ctx.showMapsNotListing ? '' : 'active']),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showMapsNotListing = false))
                        }, [
                            _hoisted_6,
                            _createTextVNode(" LISTE ")
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["d-inline-block pointerhover switchButton toMap mb-1", _ctx.showMapsNotListing ? 'active' : '']),
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showMapsNotListing = true))
                        }, [
                            _hoisted_7,
                            _createTextVNode(" KARTE ")
                        ], 2)
                    ])
                ]))
                : _createCommentVNode("", true),
            (!_ctx.showMapsNotListing && _ctx.smallDisplay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " "))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_google_maps, {
                        renderer: _ctx.clusterRenderer,
                        "geo-points": _ctx.locations
                    }, null, 8, ["renderer", "geo-points"])
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-xxl-5 pl-xxl-1 mapDimensionStorePayoutSelection", { shopListWrapperVorne: !_ctx.showMapsNotListing, 'position-absolute': _ctx.smallDisplay }]),
                    style: { "overflow-y": "auto", "z-index": "1", "overflow": "hidden" }
                }, [
                    (!_ctx.smallDisplay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_locations_by_browser_location, {
                                class: "buttonBlue",
                                "local-store-payout-only": true
                            }),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_locations_map_input_fields, { "local-store-payout-only": true })
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass(["row no-gutters bg-white overflow-auto pr-md-3", {
                                maxHeight390Desktop: !_ctx.isMobile,
                                bgGray: !_ctx.showMapsNotListing,
                                fullHeight: !_ctx.showMapsNotListing,
                                shopListBackground: _ctx.locations.length == 0,
                            }]),
                        style: { "height": "calc(100% - 110px)" }
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                            return (_openBlock(), _createBlock(_component_location_card, {
                                location: location,
                                ref_for: true,
                                ref: `location-card-${location.id}`,
                                key: index
                            }, {
                                "button-pre-opening-times": _withCtx(() => [
                                    _createElementVNode("button", {
                                        class: "mt-4 buttonBase buttonBlue [ track_red_payment_local_store_selected ]",
                                        onClick: ($event) => (_ctx.storeChosen(location.id))
                                    }, " Store auswählen ", 8, _hoisted_13)
                                ]),
                                button: _withCtx(() => [
                                    _hoisted_14
                                ]),
                                _: 2
                            }, 1032, ["location"]));
                        }), 128))
                    ], 2)
                ], 2)
            ])
        ]),
        (!_ctx.showMapsNotListing && _ctx.smallDisplay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "   "))
            : _createCommentVNode("", true)
    ], 64));
}
